<template>
  <div class="shop-detail main-top-border main-bg">
    <div class="main-wrap">
      <nav-crumb class="crumb-pt"></nav-crumb>
      <div class="detail-top">
        <!--<el-image class="banner" :src="$common.imgPath(shopInfo.backImg?shopInfo.backImg:shopInfo.headImg)"  :alt="shopInfo.shopName" lazy fit="cover"></el-image>-->
        <div class="detail-info">
          <div class="table-wrap info-top">
            <div class="table-item img-wrap">
              <el-image class="shop-img" :src="$common.imgPath(shopInfo.headImg)" :alt="shopInfo.celebrityImg" lazy fit="cover"></el-image>
            </div>
            <div class="table-item shop-desc">
              <div class="shop-name">
                {{shopInfo.shopName}}
                <!--<el-tag class="shop-tag" color="#15B249" size="small" effect="dark" v-if="shopInfo.isCelebrity">名人</el-tag>-->
                <span v-if="shopInfo.isCelebrity" class="card-txt" @click="$router.push({'path':`/celebrity/detail/${shopInfo.shopId}`})">名人资料</span>
              </div>
              <p class="flag">{{shopInfo.desc}}</p>
              <p class="shop-address">地址：{{shopInfo.address}}</p>
            </div>
            <div class="table-item">
              <ul class="num-list">
                <li>
                  <p><span class="num">{{goodsCount}}</span>件</p>
                  <span class="tit">全部拍品</span>
                </li>
                <li>
                  <p><span class="num">{{shopInfo.collectNum}}</span>人</p>
                  <span class="tit">粉丝数</span>
                </li>
                <li>
                  <p><span class="num">{{shopInfo.starNum}}</span></p>
                  <span class="tit">评分</span>
                </li>
              </ul>
            </div>
            <div class="table-item shop-opt" >
              <div class="opt-item" @click="setShopFollow()">
                <span class="icon" :class="isCollect?'collect-yellow-color':'collect-grey-color'"></span>
                <p>{{isCollect?'取消收藏':'收藏'}}</p>
              </div>
              <!--<div class="opt-item">
                <span class="icon icon-forward" ></span>
                <p>转发</p>
              </div>-->
            </div>
          </div>
          <!--<div class="info-bot">
            <div class="fl info-card">
              <el-image class="people-img" :src="$common.imgPath(shopInfo.celebrityImg)" :alt="shopInfo.celebrityName" lazy fit="cover"></el-image>
              <div class="people-info">
                <p class="people-name">{{shopInfo.celebrityName}}</p>
                <p class="people-duty">{{shopInfo.celebrityBright}} <span class="dian"></span>{{shopInfo.celebrityIdentity}}</p>
              </div>
              <div class="card-txt" @click="$router.push({'path':`/celebrity/detail/${shopInfo.shopId}`})">名人资料</div>
            </div>
            <div class="fr shop-opt" >
              <div class="opt-item" @click="setShopFollow()">
                <span class="icon" :class="isCollect?'collect-yellow-color':'collect-grey-color'"></span>
                <p>{{isCollect?'取消收藏':'收藏'}}</p>
              </div>
              <div class="opt-item">
                <span class="icon icon-forward" ></span>
                <p>转发</p>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <div class="shop-goods">
        <!--<ul class="tab-nav">
          <li class="tab-item" :class="{'active':goodsType==1}" @click="chooseType(1)">店铺商品</li>
          <li class="tab-item" :class="{'active':goodsType==2}"  @click="chooseType(2)">作品视频</li>
        </ul>-->
        <ul class="screen-tab" v-if="goodsType==1">
          <li :class="{'selected':rank==1}" @click="setRank(1)">推荐 <!--<i class="el-icon-caret-bottom"></i>--></li>
          <li :class="{'selected':rank==2}" @click="setRank(2)">销量 <!--<div class="btn-sort"><i class="btn-top el-icon-caret-top" :class="{'main-color'}"></i><i class="btn-bot el-icon-caret-bottom"></i></div>--></li>
          <li :class="{'selected':rank==3}" @click="setRank(3)">价格 <!--<div class="btn-sort"><i class="btn-top el-icon-caret-top"></i><i class="btn-bot el-icon-caret-bottom"></i></div>--></li>
        </ul>
        <shop-goods-item v-if="goodsType==1&&shopGoodsList.length>0" :goodsType="goodsType" :goodsList="shopGoodsList"></shop-goods-item>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="current"
                :hide-on-single-page="isOnePage"
                layout=" prev, pager, next,total, jumper"
                style="text-align: center;padding:20px;"
                :page-size="size"
                :total="totalPage">
        </el-pagination>
<!--
        <shop-goods-item v-if="goodsType==2&&shopVideoList.length>0" :goodsType="goodsType" :goodsList="shopVideoList" class="video-list"></shop-goods-item>
-->
      </div>
    </div>

  </div>
</template>
<script>
    import navCrumb from '../../components/crumb/index'
    import shopGoodsItem from '../../components/goods/shopGoodsItem'
    import {getShopInfoForUser,setShopFollow} from '../../api/shop'
    import {findByShopIdForShop} from '../../api/goods'
    import {videoPage} from '../../api/video'
  export default {
        data(){
            return {
                current:1,
                size:20,
                rank:1,//1默认 2销量 3价格
                goodsType:1,//1普通商品 2拍卖商品 3新品
                shopInfo:{},
                goodsCount:0,//全部拍品
                isCollect:false,//是否收藏
                isOnePage:false,//是否只有一页
                totalPage:0,
                shopGoodsList:[],
                shopVideoList:[]
            }
        },
      computed:{
          shopId(){
              return this.$route.params.id||0;
          }
      },
      components:{
          navCrumb,
          shopGoodsItem
      },
      created () {
          this.getShopInfoForUser();
          this.getShopGoodsList();
      },
      methods:{
          chooseType(type){
              /*this.current=1;
              this.goodsType=type;
              this.getShopGoodsList();*/
          },
          handleCurrentChange(current){
              this.current=current;
              this.getShopGoodsList();
          },
          setRank(val){
              this.current=1;
              this.rank=val;
              this.getShopGoodsList();
          },
          getShopInfoForUser(){
              getShopInfoForUser(this.shopId).then(res=>{
                  if(res.data){
                      this.shopInfo=res.data.shop;
                      this.goodsCount=res.data.goodsCount;
                      this.isCollect=res.data.isCollect;
                  }
              }).catch(err=>{
                  console.log(err)
              })
          },
          getShopGoodsList(){
              findByShopIdForShop({
                  current:this.current,
                  size:this.size,
                  shopId:this.shopId,
                  status:1,
                  rank:this.rank
              }).then(res=>{
                  const {records,total}=res.data
                  this.shopGoodsList=records
                  this.totalPage=total;
                  this.isOnePage=total<=this.size?true:false;
              })
          },
          getVideoList(){
              videoPage({
                  shopId:this.shopId
              }).then(res=>{
                  this.shopVideoList=res.data.records;
              })
          },
          //操作关注/取消 店铺
          setShopFollow(){
              setShopFollow({
                  shopId:this.shopId
              }).then(res=>{
                  this.isCollect=res.data;
              })
          },
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";
 .crumb-pt{
   padding:15px 0 24px 0;
 }
  .detail-top{
    .banner{
      width:100%;
      height:330px;
      object-fit: cover;
      background-color:$main-color;
    }
    .detail-info{
      padding:20px 30px ;
      background-color:#ffffff;
      .info-top{
        .img-wrap{
          width:100px;
          height:100px;
        }
        .shop-img{
          width:100px;
          height:100px;
          background-color:#fff;
          -webkit-border-radius: 10px;
          -moz-border-radius: 10px;
          border-radius: 10px;
        }
        .shop-desc{
          padding-left:10px;
          width: 50%;
          .shop-name{
            font-size:20px;
            color:#222222;
            font-weight:600;
            /*padding-top:10px;*/
            .shop-tag{
              vertical-align: middle;
              width:40px;
              height:20px;
              line-height:20px;
              background:rgba(21,178,73,1);
              border-radius:2px;
              color: #ffffff;
              border:none;
              margin-left:15px;
              font-weight:500;
            }
            .card-txt{
              /*vertical-align: middle;*/
              /*display: table-cell;*/
              /*text-align: right;*/
              color:$main-color;
              font-size:14px;
              margin-left:15px;
              text-decoration:underline;
              cursor: pointer;
            }
          }
          .flag{
            padding:10px 0;
            color:#686868;
            font-size:16px;
          }
          .shop-address{
            font-size:16px;
            color:#222222;
          }

        }
        .num-list{
          color:#222222;
          display: table;
          li{
            display: table-cell;
            vertical-align: middle;
            font-size:20px;
            text-align: center;
            &+li{
              padding-left:50px;
            }
            .num{
              font-size:20px;
              font-weight: 600;
            }
            .tit{
              font-size:14px
            }
          }

        }
      }
      .shop-opt{
        display: table;
        height:120px;
        .opt-item{
          display: table-cell;
          vertical-align: middle;
          font-size: 14px;
          color: #333333;
          text-align: center;
          width: 60px;
          &+.opt-item{padding-left:50px;}
          @include hover-color;
          .icon{
            display: block;
            width:20px;
            height:20px;
            margin:0 auto 10px;
          }
          .icon-forward{background:url("~@/assets/images/icons/icon-forward.png")no-repeat center;background-size:100%;}
        }
      }
      .info-bot{
        padding-top:30px;
        overflow: hidden;
        .info-card{
          width:584px;
          padding:20px 40px;
          border:1px solid #DDD9D9;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          display: table;
          .people-img{
            display: table-cell;
            width:80px;
            height:80px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            background-color:$main-color;
          }
          .people-info{
            vertical-align: middle;
            display: table-cell;
            padding-left:20px;
            width:60%;
            .people-name{
              font-size:22px;
              font-weight:600;
              color:#222222;
              padding-bottom:10px;
            }
            .people-duty{
              .dian{
                display: inline-block;
                margin:0 8px;
                width:5px;height:5px;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                background-color: #666666;
              }
            }
          }
          .card-txt{
            vertical-align: middle;
            display: table-cell;
            text-align: right;
            color:$main-color;
            font-size:20px;
          }
        }

      }

    }
  }
  .shop-goods{
    padding-bottom:30px;
    margin:14px 0;
    background-color:#ffffff;
    .tab-nav{
      border-bottom:1px solid #D7D7D7;
      font-size:24px;
      padding:0 35px;
      .tab-item{
        &+.tab-item{
          margin-left:50px;
        }
        display: inline-block;
        padding:30px 16px;
        position: relative;
        &.active{
          color:$main-color;
          &:after{
            content: '';
            position: absolute;
            bottom: 0;
            left:0;
            width: 100%;
            height:4px;
            background-color:$main-color;
            -webkit-border-radius: 2px;
            -moz-border-radius: 2px;
            border-radius: 2px;
          }
        }
      }
    }
    .screen-tab{
      padding:20px 35px 30px 36px;
      overflow: hidden;
      font-size:18px;
      li{
        float: left;
        cursor: pointer;
        &:hover{color:$main-color;}
        .btn-sort{
          display: inline-block;
          position: relative;
          .btn-top{
            position: absolute;
            top: -20px;
            left:0;
          }
          .btn-bot{
            position: absolute;
            top: -10px;
            left:0;
          }
        }
        &.selected{
          font-weight:600;
        }
        &+li{
          margin-left:100px;
        }
        i{
          color:#D1D1D1;
        }
      }
    }
  }
.video-list{padding-top:20px;}

</style>
